// extracted by css-extract-rspack-plugin
export default {"time":"nH_RB4rK7wRFIQ1n","currentTime":"iunZ5efRtdI4Vsj2","hiding":"eodUJXJLz8ei9k_B"};